import script from "./AdminInvitesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminInvitesPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminInvitesPage.vue?vue&type=style&index=0&id=609995e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609995e6"]])

export default __exports__